<template>
    <div>
        <Loader :loader="loader" />

        <b-card :title="$t('miniCurriculum.personalData')" v-if="!loader">
            <b-media no-body>
                <b-media-body class="ml-3">
                    <b-row>
                        <b-col md="12" xl="12" sm="12">
                            <label for="name">{{
                                $t('miniCurriculum.form.label.name')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="name"
                                :value="currentUser.name || '-'"
                                disabled
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="6" xl="6" sm="6">
                            <label for="birth_date">{{
                                $t('miniCurriculum.form.label.birthDate')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="birth_date"
                                :value="getFormatDate(currentUser.birth_date)"
                                disabled
                            />
                        </b-col>

                        <b-col md="3" xl="3" sm="3">
                            <label for="admission">{{
                                $t('miniCurriculum.form.label.admission')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="admission_date"
                                :value="
                                    getFormatDate(currentUser.admission_date)
                                "
                                disabled
                            />
                        </b-col>

                        <b-col md="3" xl="3" sm="3">
                            <label for="occupation">{{
                                $t('miniCurriculum.form.label.occupation')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="occupation"
                                :value="currentUser.occupation || '-'"
                                disabled
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="6">
                            <label>
                                {{
                                    $t('miniCurriculum.form.label.departments')
                                }}
                            </label>
                            <b-form-textarea
                                class="mb-2"
                                :value="
                                    getAListOfDepartments(currentUser.sections)
                                "
                                disabled
                            />
                        </b-col>

                        <b-col md="6" xl="6" sm="6">
                            <label for="direction">{{
                                $t('miniCurriculum.form.label.direction')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="direction"
                                :value="currentUser.directory || '-'"
                                disabled
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="6" xl="6" sm="6">
                            <label for="email">{{
                                $t('miniCurriculum.form.label.email')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="email"
                                :value="currentUser.email || '-'"
                                disabled
                            />
                        </b-col>

                        <b-col md="6" xl="6" sm="6">
                            <label for="manager">{{
                                $t('miniCurriculum.form.label.manager')
                            }}</label>
                            <b-form-input
                                class="mb-2"
                                ref="manager"
                                :value="currentUser.manager_name || '-'"
                                disabled
                            />
                        </b-col>
                    </b-row>
                </b-media-body>
            </b-media>
        </b-card>
    </div>
</template>

<script>
import api from '@/services/api'
import { formatDate } from '@/lib/date'
import Loader from '@/views/components/loader'
import Avatar from 'vue-avatar'

export default {
    name: 'MiniCurriculum',
    data() {
        return {
            currentUser: {},
            loader: true,
        }
    },
    components: {
        Loader,
        Avatar,
    },
    mounted() {
        this.getCurrentUserFromAPI()
    },
    methods: {
        getCurrentUserFromAPI() {
            const { id } = this.$route.params

            return api
                .get(`/users/${id}`, {
                    params: {
                        transform: 'role',
                        with: 'role;company;sections',
                    },
                })
                .then(resp => {
                    const {
                        data: { data },
                    } = resp
                    this.currentUser = data
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loader = false
                    this.$emit('ready')
                })
        },
        getFormatDate(data) {
            return data != null ? formatDate(data, 'DD/MM/YYYY') : ' - '
        },
        getDepartmentsFromSections(sections) {
            return sections.filter(section => section.type === 'department')
        },
        getOnlyDepartmentsName(departments) {
            return departments.map(department => department.name)
        },
        implodeDepartments(departments, separator = ', ') {
            return departments.join(separator)
        },
        getAListOfDepartments(sections) {
            const departments = this.getDepartmentsFromSections(sections)
            const departmentsName = this.getOnlyDepartmentsName(departments)
            return this.implodeDepartments(departmentsName)
        },
    },
}
</script>
